import './winmock2/style';
import FormStructure from './winmock2/form_structure';

export default FormStructure;